import { useEffect } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Phone } from "lucide-react";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { BUSINESS, PHASE3_BRAND_VOICE } from "@/lib/constants";
import { track, EVENTS } from "@/lib/analytics";

export default function StormBanner() {
    const { settings } = useSiteSettings();
    const isActive = !!settings?.storm_season_mode?.is_active;
    const reason = settings?.storm_season_mode?.reason;

    useEffect(() => {
        if (isActive) track(EVENTS.STORM_BANNER_VIEW, { reason });
    }, [isActive, reason]);

    if (!isActive) return null;
    return (
        <div className="a1-storm-bg" role="region" aria-label="Storm season announcement" data-testid="storm-banner">
            <div className="a1-container py-3 flex flex-col md:flex-row md:items-center md:gap-4">
                <div className="flex items-start gap-2 flex-1">
                    <AlertTriangle size={22} style={{ color: "var(--color-storm)" }} className="mt-0.5 shrink-0" />
                    <div>
                        <p className="font-bold uppercase tracking-wider text-sm" style={{ color: "var(--color-storm)" }}>
                            Storm Season — Storm Damage Estimates Available
                        </p>
                        {reason ? (
                            <p className="text-sm" style={{ color: "var(--color-text-muted)" }}>{reason}</p>
                        ) : null}
                        <p className="text-sm mt-1" style={{ color: "var(--color-text)" }}>
                            If your pool cage was damaged by a recent storm, send us photos and we'll get you on the schedule. {PHASE3_BRAND_VOICE.cautious_storm}
                        </p>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-2 mt-3 md:mt-0">
                    <Link
                        to="/storm-damage"
                        onClick={() => track(EVENTS.STORM_CTA_CLICK, { placement: "storm-banner" })}
                        className="a1-btn-primary"
                        data-testid="storm-banner-cta"
                    >
                        Request Storm Damage Repair
                    </Link>
                    <a
                        href={`tel:${BUSINESS.phoneTel}`}
                        onClick={() => track(EVENTS.PHONE_CLICK, { placement: "storm-banner" })}
                        className="a1-btn-secondary"
                    >
                        <Phone size={18} /> Call Now
                    </a>
                </div>
            </div>
        </div>
    );
}
